import { spriteMap } from '../main/spriteMap-sidecar'
import { layers } from '../main/layers-sidecar'
import { frameInfo } from '../main/frameInfo-sidecar'
import { l } from '../lib/imports'

const tumult = require('tumult')

export function create() {
  let w = 80
  let h = 60
  let s = 60 / 2 / 2
  let layer = layers.getLayers().ui
  let fi = frameInfo.fi32(1, 2, 11)
  let simScale = 16
  fi.scale = 0.25 / 2

  const simplex2 = new tumult.Simplex2(l.random(true))

  for (let j = 0; j < h; j++) {
    for (let i = 0; i < w; i++) {
      let image = spriteMap.createImageFromFrameInfo(
        layer,
        fi,
        s / 2 + s * i,
        s / 2 + s * j,
      )
      //image.tint = ((i + j) / (w - 1 + h - 1)) * 0xffffff

      let dFromCenterX = i - w / 2
      let dFromCenterY = j - h / 2
      let dFromCenter =
        Math.sqrt(dFromCenterX * dFromCenterX + dFromCenterY * dFromCenterY) /
        (h / 2)
      let idFromCenter = dFromCenter
      idFromCenter *= idFromCenter

      let sim = simplex2.gen(i / simScale, j / simScale)
      sim -= idFromCenter * 1

      if (sim < -1) {
        sim = -1
      }

      // let p = (i + j) / (w - 1 + h - 1)
      let p = (sim + 1) / 2
      let c = Math.floor(255 * p)

      let tint = c + c * 256 + c * 256 * 256

      if (sim < 0) {
        p = sim / 1.33 + 1
        c = Math.floor(255 * p)
        tint = c
      }
      if (sim > 0) {
        p = (sim + 0.5) / 2
        c = Math.floor(255 * p)
        tint = 0 + c * 256 + 0 * 256 * 256
      }
      if (sim > 0.5) {
        p = (sim - 0.5) * 1.25 + 0.25
        c = Math.floor(255 * p)
        tint = c + c * 256 + c * 256 * 256
      }

      image.tint = tint
      // console.log(sim, p, idFromCenter, i, j)
    }
  }
}
